import isArrayLike from './is-array-like';
export default (function (value) {
    return isArrayLike(value) ? Array.prototype.slice.call(value) : [];
});
//# sourceMappingURL=to-array.js.map